import Nullstack from 'nullstack';
export default function IconTrashOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-trash-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "3",
    x2: "21",
    y2: "21"
  }), "   ", Nullstack.element("path", {
    d: "M4 7h3m4 0h9"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "11",
    x2: "10",
    y2: "17"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "14",
    x2: "14",
    y2: "17"
  }), "   ", Nullstack.element("path", {
    d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l.077 -.923"
  }), "   ", Nullstack.element("line", {
    x1: "18.384",
    y1: "14.373",
    x2: "19",
    y2: "7"
  }), "   ", Nullstack.element("path", {
    d: "M9 5v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
  }), " ");
}